// extracted by mini-css-extract-plugin
module.exports = {"DropZone":"DropZone_DropZone_1Wkap","isDragging":"DropZone_isDragging_27voC","Content":"DropZone_Content_25KPi","hasError":"DropZone_hasError_3qeRI"};